import React from "react";
import { connect, ConnectedProps } from "react-redux";
import { Container, Dimmer, Loader } from "semantic-ui-react";
import { executeBaseRequests } from "../actions/appStatus/appStatus";
import CustomFailure from "../components/common/CustomFailure";
import CustomSuccess from "../components/common/CustomSuccess";
import HeaderMenu from "../components/common/Header";
import { AppDispatch, RootState } from "../reducers";

const mapStateToProps = (state: RootState) => ({
  isMainAppLoading: state.appStatus.isMainAppLoading,
  userClaims: state.users.userClaims,
  showFailureMessage: state.statusMessages.showFailureMessage,
  submitFailedMessageHeader: state.statusMessages.submitFailedMessageHeader,
  submitFailedMessageContent: state.statusMessages.submitFailedMessageContent,
  showSuccessMessage: state.statusMessages.showSuccessMessage,
  submitSucceededMessageHeader: state.statusMessages.submitSucceededMessageHeader,
  submitSucceededMessageContent: state.statusMessages.submitSucceededMessageContent,
  displayMainAppError: state.appStatus.displayMainAppError,
  displayMainAppErrorMessage: state.appStatus.displayMainAppErrorMessage
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  executeBaseRequests: () => dispatch(executeBaseRequests())
});

const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;
type MainViewProps = { routes: React.ReactElement } & PropsFromRedux;

class MainView extends React.Component<MainViewProps> {
  constructor(props: MainViewProps) {
    super(props);
    if ((props.userClaims.selectedRoles ?? []).length > 0) {
      props.executeBaseRequests();
    }
  }

  render() {
    const { isMainAppLoading, displayMainAppError, displayMainAppErrorMessage } = this.props;
    return (
      <>
        <Dimmer active={isMainAppLoading || displayMainAppError}>
          {isMainAppLoading && <Loader size="huge"> Loading... </Loader>}
          {displayMainAppError && (
            <CustomFailure
              header="An error occurred while initializing the application"
              content={displayMainAppErrorMessage}
            />
          )}
        </Dimmer>
        {!(isMainAppLoading || displayMainAppError) && (
          <>
            <HeaderMenu />
            {this.props.showFailureMessage && (
              <CustomFailure
                header={this.props.submitFailedMessageHeader}
                content={this.props.submitFailedMessageContent}
              />
            )}
            {this.props.showSuccessMessage && (
              <CustomSuccess
                header={this.props.submitSucceededMessageHeader}
                content={this.props.submitSucceededMessageContent}
              />
            )}
            <Container> {this.props.routes} </Container>
          </>
        )}
      </>
    );
  }
}

export default connector(MainView);
